import Vue from 'vue'
import App from './App'
import router from './routes.js'
import Vuetify from 'vuetify'
import axios from 'axios'
import Auth from './plugins/auth.js'
import VeeValidate from 'vee-validate';
import Spinner from 'vue-simple-spinner'


// index.js or main.js
import 'vuetify/dist/vuetify.min.css'
import './assets/style.css'
Vue.use(Vuetify)
Vue.use(Auth);
Vue.use(VeeValidate);
Vue.config.productionTip = false


axios.interceptors.request.use(function (config) {

    if (config.url[0] === "/") {
      config.url = "http://songa.iq/app/api" + config.url;

      var token = Vue.auth.getToken();
      if (token) {
        config.headers['Content-Type'] = 'application/json';
        config.headers['Authorization'] = 'Bearer ' + token;
      }
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    var admin = Vue.auth.getAdmin();
    if (admin === "true") {
      next();
    } else if (admin === "false") {
      next({
            path: '/agency',
            query: { redirect: to.fullPath }
        });
    } else if (to.matched.some(function(record) { return record.meta.requiresAuth })
        && !Vue.auth.loggedIn())
    {
        next({
            path: '/auth/login',
            query: { redirect: to.fullPath }
        });
    }
  } else if (to.matched.some(function (record) { return record.meta.requiresAuth })
    && !Vue.auth.loggedIn()) {
    next({
      path: '/auth/login',
      query: { redirect: to.fullPath }
    });
  } else if (Vue.auth.loggedIn() && Vue.auth.getAdmin() === "true"){
    next({
      path: '/admin',
    });
  } else {
      next(); // make sure to always call next()!
  }
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  components: {
    Spinner
  }
})



// WEBPACK FOOTER //
// ./src/main.js